const storageKey = (userId: string) => `bb:pass-payment-return:${userId}`;
export const isPassPaymentReturn = (value: unknown, orderId: string, now: number): boolean =>
  typeof value === 'object' &&
  value !== null &&
  'orderId' in value &&
  value.orderId === orderId &&
  /^[0-9a-f-]{36}$/i.test(orderId) &&
  'at' in value &&
  typeof value.at === 'number' &&
  Number.isFinite(value.at) &&
  now >= value.at &&
  now - value.at < 3 * 3_600_000;

export function rememberPassPayment(userId: string, orderId: string): void {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify({ orderId, at: Date.now() }));
  } catch {
    /* Payment status recovery still works if browser storage is unavailable. */
  }
}
export function restorePassPaymentReturn(userId: string, orderId: string): boolean {
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(storageKey(userId)) ?? 'null');
    if (!isPassPaymentReturn(saved, orderId, Date.now())) return false;
    localStorage.setItem(`bb:pending-payment:${userId}`, orderId);
    // Navigation effects can replay before the router commits (including StrictMode).
    // Keep the exact-order marker until its bounded expiry so repeated resolution is stable.
    return true;
  } catch {
    return false;
  }
}
